import { usePetitionGuidesPageData } from '#src/app/pages/petitionGuides/landing/pageContext';

type Step = {
	title: string;
	description: string;
	articles: Array<{
		title: string;
		slug: string;
	}>;
};

type Result = ModelHookResult<{
	steps: Step[];
}>;

export function usePetitionSteps(): Result {
	const {
		data: { stepsCollection },
	} = usePetitionGuidesPageData();

	const steps = stepsCollection.items.map((step) => ({
		title: step.title,
		description: step.description,
		articles: step.articlesCollection.items.map((article) => ({
			title: article.articleTitle,
			slug: article.slug,
		})),
	}));

	return {
		data: {
			steps,
		},
	};
}
